<template>
  <b-sidebar
    id="sidebar"
    :visible="sidebarActive"
    no-close-on-route-change
    no-header
  >
    <b-button
      block
      :class="$route.path == '/' ? 'first-layer--active' : 'first-layer'"
      to="/"
      @click.prevent="onCollapse(0)"
    >
      <img
        v-if="$route.path == '/'"
        class="indicator"
        :src="asset('imgs/icons/active-indicator.png')"
        alt="active-indicator"
      />
      Dashboard
    </b-button>
    <div v-for="section in sections" :key="section.title">
      <b-button
        :href="'#' + section.title"
        block
        class="first-layer"
        :class="
          containsLink(section.links) ? 'first-layer--active' : 'first-layer'
        "
        @click.prevent="onCollapse(section.id)"
      >
        <img
          v-if="containsLink(section.links)"
          class="indicator"
          :src="asset('imgs/icons/active-indicator.png')"
          alt="active-indicator"
        />
        {{ section.title }}
        <img
          :class="visible == section.id ? 'arrow--active' : 'arrow'"
          alt="arrow-small"
          :src="
            containsLink(section.links)
              ? asset('imgs/icons/arrow-small-red.png')
              : asset('imgs/icons/arrow-small.png')
          "
        />
      </b-button>
      <b-collapse
        :id="section.title"
        :visible="visible == section.id"
        accordion="first layer"
        role="tabpanel"
      >
        <div v-for="link in section.links || []" :key="link.title">
          <b-button
            v-if="!(isMobile && link.descktopOnly)"
            :class="
              $route.path.includes(link.href)
                ? 'second-layer--active'
                : 'second-layer'
            "
            block
            :to="link.href"
          >
            {{ link.title }}
          </b-button>
        </div>
      </b-collapse>
    </div>
    <b-button
      v-if="canRefundOrders || isAdmin"
      block
      :class="$route.path.includes('/coupons') ? 'first-layer--active' : 'first-layer'"
      to="/coupons"
    >
      <img
        v-if="$route.path.includes('/coupons')"
        class="indicator"
        :src="asset('imgs/icons/active-indicator.png')"
        alt="active-indicator"
      />
      Coupons
    </b-button>
  </b-sidebar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SidebarLayout',
  data() {
    return {
      visible: null,
      links: [
        {
          title: 'Brands',
          href: '/brands',
          section: 0,
          roles: ['brand', 'hub'],
        },
        {
          title: 'Menus',
          href: '/menus',
          section: 0,
          roles: ['brand', 'hub'],
        },
        {
          title: 'Menu Items',
          href: '/menu-items',
          section: 0,
          roles: ['kitchen', 'hub'],
        },
        {
          title: 'Items',
          href: '/items',
          section: 0,
          roles: ['kitchen', 'brand', 'hub'],
        },
        {
          title: 'Modifiers',
          href: '/modifiers',
          section: 0,
          roles: ['brand', 'hub'],
        },
        {
          title: 'Imports & Exports',
          href: '/imports',
          section: 0,
          roles: ['brand'],
        },
        {
          title: 'Orders',
          href: '/orders',
          section: 1,
          roles: ['hub'],
        },
        {
          title: 'Kitchen Orders',
          href: '/kitchen-orders',
          section: 1,
          roles: ['hub', 'kitchen'],
        },
        {
          title: 'Deliveries',
          href: '/deliveries',
          section: 1,
          roles: ['hub'],
        },
        {
          title: 'Order Items',
          href: '/order-items',
          section: 1,
          roles: ['kitchen', 'hub'],
        },
        {
          title: 'Dispatch',
          href: '/dispatch',
          descktopOnly: true,
          section: 1,
          roles: ['hub'],
        },
        {
          title: 'API Keys',
          href: '/api-keys',
          section: 2,
          roles: ['organization'],
        },
        {
          title: 'Networks',
          href: '/networks',
          section: 2,
          roles: ['organization'],
        },
        {
          title: 'Menus',
          href: '/organization-menus',
          section: 2,
          roles: ['organization'],
        },
      ],
    };
  },
  computed: {
    ...mapGetters('session', [
      'brandAdmin',
      'hubAdmin',
      'kitchenAdmin',
      'organizationAdmin',
      'canRefundOrders',
      'isAdmin',
      'sidebarActive',
      'isMobile',
    ]),
    sections() {
      const sections = [
        {
          id: 1,
          title: 'Menus',
          links: [],
        },
        {
          id: 2,
          title: 'Orders',
          links: [],
        },
        {
          id: 3,
          title: 'Organization',
          links: [],
        },
      ];

      for (let i = 0; i < this.links.length; i += 1) {
        let include = false;
        const { section, roles, title, href, descktopOnly } = this.links[i];

        if (this.brandAdmin && roles.includes('brand')) {
          include = true;
        } else if (this.kitchenAdmin && roles.includes('kitchen')) {
          include = true;
        } else if (this.hubAdmin && roles.includes('hub')) {
          include = true;
        } else if (this.organizationAdmin && roles.includes('organization')) {
          include = true;
        }

        if (include && sections[section]) {
          sections[section].links.push({
            title,
            href,
            descktopOnly,
          });
        }
      }

      // Filter sections based on user permissions
      return sections.filter((section, index) => {
        if (index === 0) return true; // Menus - always show
        if (index === 1) return this.hubAdmin || this.kitchenAdmin; // Orders
        if (index === 2) return this.organizationAdmin; // Organization
        return false;
      });
    },
  },
  watch: {
    sections() {
      this.setCurrentTab();
    },
  },
  created() {
    this.setCurrentTab();
  },
  methods: {
    containsLink(links) {
      if (!links || !Array.isArray(links)) {
        return false;
      }
      if (links.find((element) => this.$route.path.includes(element.href))) {
        return true;
      }
      return false;
    },
    onCollapse(id) {
      if (this.visible === id) {
        this.visible = null;
      } else {
        this.visible = id;
      }
    },
    setCurrentTab() {
      for (let i = 0; i < this.sections.length; i += 1) {
        if (
          this.sections[i].links &&
          this.sections[i].links.find((element) =>
            this.$route.path.includes(element.href)
          )
        ) {
          this.visible = this.sections[i].id;
        }
      }
    },
  },
};
</script>
